import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import MobileMenu from './MobileMenu';
import { AnimatePresence, MotionConfig, motion } from 'framer-motion';

const Layout = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <MotionConfig reducedMotion="user">
      <div className="min-h-screen min-w-0 bg-white">
      <AnimatePresence>
        {mobileMenuOpen && (
          <>
            <motion.button
              type="button"
              aria-label="Close navigation menu"
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.5 }}
              exit={{ opacity: 0 }}
              onClick={() => setMobileMenuOpen(false)}
              className="fixed inset-0 z-40 cursor-default bg-black lg:hidden"
            />
            <MobileMenu isOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />
          </>
        )}
      </AnimatePresence>

      <div className="hidden lg:fixed lg:inset-y-0 lg:flex lg:w-64 lg:flex-col">
        <Sidebar isOpen />
      </div>

      <div className="flex min-h-screen min-w-0 flex-col lg:pl-64">
        <Navbar onMenuClick={() => setMobileMenuOpen(true)} />

        <main className="min-w-0 flex-1 p-4 sm:p-6 lg:p-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="mx-auto w-full min-w-0 max-w-7xl"
          >
            <Outlet />
          </motion.div>
        </main>

        <footer className="border-t border-gray-100 bg-white px-4 py-4 sm:px-6">
          <div className="max-w-7xl mx-auto text-center text-sm text-gray-500">
            © {new Date().getFullYear()} Covrly Admin Panel. All rights reserved.
          </div>
        </footer>
      </div>
      </div>
    </MotionConfig>
  );
};

export default Layout;
